import { Component, Prop, Element, h, Host } from "@stencil/core";
import { BlogResult } from "./blog-result";
import { StringUtils } from "../../core/utils/StringUtils";

@Component({
    tag: "snt-blog-results",
    styleUrl: "./blog-results-component.scss",
    shadow: false,
})
export class SntBlogResultsComponent {
    @Element() hostElement: HTMLElement;
    private blogResults: BlogResult[] = [];

    @Prop({ reflect: true }) blogResultsString: string = StringUtils.empty();

    componentWillRender(): void {
        this.blogResults = JSON.parse(this.blogResultsString);
    }

    render() {
        return (
            <Host>
                {this.renderFirstRow()}
                {this.blogResults.length > 2 ? this.renderRows() : null}
            </Host>
        );
    }

    renderFirstRow() {
        const firstRowJson =
            '{"extra-small": 1,"small": 1,"medium": 2,"large": 2,"extra-large": 2}';
        return (
            <snt-multi-column-mixed
                class="first-row no-bottom with-gutter"
                column-count={firstRowJson}
            >
                {this.blogResults.slice(0, 2).map((blog: BlogResult) => {
                    return (
                        <div class="column">
                            <snt-blog
                                imgSrc={blog.imageSource}
                                titleText={blog.titleText}
                                tagText={blog.tagText}
                                timeToRead={blog.timeToRead}
                                blogLink={blog.blogLink}
                            ></snt-blog>
                        </div>
                    );
                })}
            </snt-multi-column-mixed>
        );
    }

    renderRows() {
        const resultRowJson =
            '{"extra-small": 1,"small": 1,"medium": 2,"large": 3,"extra-large": 3}';
        return (
            <snt-multi-column-mixed
                class="result-rows with-gutter"
                column-count={resultRowJson}
                aria-live="polite"
            >
                {this.blogResults
                    .slice(2, this.blogResults.length)
                    .map((blog: BlogResult) => {
                        return (
                            <div class="column">
                                <snt-blog
                                    imgSrc={blog.imageSource}
                                    titleText={blog.titleText}
                                    tagText={blog.tagText}
                                    timeToRead={blog.timeToRead}
                                    blogLink={blog.blogLink}
                                ></snt-blog>
                            </div>
                        );
                    })}
            </snt-multi-column-mixed>
        );
    }
}
